(() => {
async function $f47fc52e30e0a11a$export$2cdf1b96a9f86d16(text) {
    await navigator.clipboard.writeText(text);
}


//
// After a successful login we are redirected to the UI with our username
// and a JWT token. We need to save these in local storage so Verdaccio
// thinks we are logged in.
//
function $8276252678408131$export$787d85d17a1ab0c9(credentials) {
    localStorage.setItem("username", credentials.username);
    localStorage.setItem("token", credentials.uiToken);
    localStorage.setItem("npm", credentials.npmToken);
}
function $8276252678408131$export$d1b63878dfcc70a6() {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("npm");
}
function $8276252678408131$export$256a5a3564694cfc() {
    const username = localStorage.getItem("username");
    const token = localStorage.getItem("token");
    const npm = localStorage.getItem("npm");
    const isLoggedIn = !!username && username !== "null" && !!token && token !== "null" && !!npm && npm !== "null";
    return isLoggedIn;
}
function $8276252678408131$export$65f22a49577e07ee(credentials) {
    return (0, credentials.username) && credentials.uiToken && credentials.npmToken;
}


// import { loginHref, logoutHref } from "../../constants"

/**
 * Returns cookies as an object
 */ function $78dac64b38b5f677$export$d2e637738f5e6ae8(cookieStr) {
    return cookieStr.split(";").filter((str)=>str.includes("=")).map((str)=>str.split("=")).reduce((result, [key, value])=>({
            ...result,
            [decodeURIComponent(key.trim())]: decodeURIComponent(value.trim())
        }), {});
}
function $78dac64b38b5f677$export$9369b12211e1fce4(action, n) {
    for(let i = 0; i < 20; i++)setTimeout(()=>action(), 100 * i);
}
function $78dac64b38b5f677$var$pathContainsElement(selector, e) {
    const path = e.path || e.composedPath?.();
    const element = document.querySelector(selector);
    return path.includes(element);
}
function $78dac64b38b5f677$export$60561518b076cb2c(selector, callback) {
    console.log("interruptClick triggered");
    const handleClick = (e)=>{
        if ($78dac64b38b5f677$var$pathContainsElement(selector, e)) {
            e.preventDefault();
            e.stopPropagation();
            callback();
        }
    };
    const capture = true;
    document.addEventListener("click", handleClick, capture);
}


function $c2243597a68bc60b$var$saveAndRemoveCookies() {
    console.log("inside save n remove");
    const credentials = (0, $78dac64b38b5f677$export$d2e637738f5e6ae8)(document.cookie);
    if (!(0, $8276252678408131$export$65f22a49577e07ee)(credentials)) return;
    (0, $8276252678408131$export$787d85d17a1ab0c9)(credentials);
    // Object.keys(credentials).forEach(
    //   (key) => (document.cookie = `${key}=;expires=${new Date(0).toUTCString()}`),
    // )
    // location.reload()
    const server = "https://dev.hyperdart.com";
    console.log("server", server, "development");
// window.location.href = `${server}/partner-portal/token`
}
function $c2243597a68bc60b$export$2cd8252107eb640b(options) {
    $c2243597a68bc60b$var$saveAndRemoveCookies();
    const { updateUsageInfo: updateUsageInfo, logoutButton: logoutButton, loginButton: loginButton } = options;
    document.addEventListener("click", ()=>(0, $78dac64b38b5f677$export$9369b12211e1fce4)(updateUsageInfo, 10));
    (0, $78dac64b38b5f677$export$9369b12211e1fce4)(updateUsageInfo, 20);
}


//
// Replace the default npm usage info and displays the authToken that needs
// to be configured.
//
function $711d14fa60d802ac$export$9dc0174526f4c7e3() {
    const username = localStorage.getItem("username");
    if (!username) return "Click the login button to authenticate with hyperdart Portal.";
    const configBase = window.VERDACCIO_API_URL ? window.VERDACCIO_API_URL.replace(/^https?:/, "").replace(/-\/verdaccio\/$/, "") : `//${location.host}${location.pathname}`;
    const authToken = localStorage.getItem("npm");
    return [
        `npm publish --registry ${configBase}`,
        `npm config set ${configBase}:_authToken="${authToken}"`
    ].join("\n");
}




const $b581aa09546ecf82$var$loginButtonSelector = `[data-testid="header--button-login"]`;
const $b581aa09546ecf82$var$logoutButtonSelector = `[data-testid="header--button-logout"]`;
const $b581aa09546ecf82$var$tabSelector = `[data-testid="tab-content"]`;
const $b581aa09546ecf82$var$logoutDialogButton = `[data-testid="logOutDialogIcon"]`;
const $b581aa09546ecf82$var$helpCardSelector = `[data-testid="help-card"]`;
function $b581aa09546ecf82$var$HideLogoutButton() {
    const logoutButton = document.querySelector($b581aa09546ecf82$var$logoutDialogButton);
    if (logoutButton) logoutButton.style.display = "none";
}
function $b581aa09546ecf82$var$updateUsageInfo() {
    $b581aa09546ecf82$var$HideLogoutButton();
    console.log("Inside updateUsageInfo function");
    const loggedIn = (0, $8276252678408131$export$256a5a3564694cfc)();
    if (!loggedIn) {
        (0, $8276252678408131$export$d1b63878dfcc70a6)();
        const server = "https://dev.hyperdart.com";
        location.href = `${server}/hd/login`;
    } else {
        const tabs = document.querySelectorAll($b581aa09546ecf82$var$tabSelector);
        if (!tabs) return;
        const usageInfoLines = (0, $711d14fa60d802ac$export$9dc0174526f4c7e3)().split("\n").reverse();
        tabs.forEach((tab)=>{
            const alreadyReplaced = tab.getAttribute("replaced") === "true";
            if (alreadyReplaced) return;
            const commands = Array.from(tab.querySelectorAll("button")).map((node)=>node.parentElement).filter((node)=>!!node.innerText.match(/^(npm|pnpm|yarn)/));
            if (!commands.length) return;
            usageInfoLines.forEach((info)=>{
                const cloned = commands[0].cloneNode(true);
                const textEl = cloned.querySelector("span");
                textEl.innerText = info;
                const copyEl = cloned.querySelector("button");
                copyEl.style.visibility = loggedIn ? "visible" : "hidden";
                copyEl.onclick = (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    (0, $f47fc52e30e0a11a$export$2cdf1b96a9f86d16)(info);
                };
                commands[0].parentElement.appendChild(cloned);
                tab.setAttribute("replaced", "true");
            });
            // Remove commands that don't work with oauth
            commands.forEach((node)=>{
                if (node.innerText.includes("adduser") || node.innerText.includes("set password") || node.innerText.includes("set registry")) {
                    node.parentElement.removeChild(node);
                    tab.setAttribute("replaced", "true");
                }
            });
        });
        const helpCard = document.querySelector($b581aa09546ecf82$var$helpCardSelector);
        if (helpCard) {
            helpCard.innerHTML = "";
            const newContent = document.createElement("div");
            newContent.style.padding = "20px";
            const newContentHeading = document.createElement("div");
            newContentHeading.innerHTML = `Publish Your First Package:`;
            newContentHeading.style.fontSize = "20px";
            newContentHeading.style.fontWeight = "600";
            newContentHeading.style.padding = "20px 20px 0 20px";
            const messageEl = document.createElement("div");
            usageInfoLines.forEach((item, index)=>{
                const copyEl = document.createElement("span");
                copyEl.style.cursor = "pointer";
                copyEl.style.float = "right";
                copyEl.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M272 0H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128H192v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"/></svg>
  `;
                copyEl.onclick = (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    (0, $f47fc52e30e0a11a$export$2cdf1b96a9f86d16)(item);
                    copyEl.innerHTML = "";
                    messageEl.textContent = "Copied To Clipboard!";
                    messageEl.style.fontSize = "14px";
                    messageEl.style.color = "#F05F40";
                    messageEl.style.fontWeight = "bold";
                    copyEl.appendChild(messageEl);
                    setTimeout(()=>{
                        copyEl.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 512 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M272 0H396.1c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9V336c0 26.5-21.5 48-48 48H272c-26.5 0-48-21.5-48-48V48c0-26.5 21.5-48 48-48zM48 128H192v64H64V448H256V416h64v48c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48z"/></svg>
    `;
                        copyEl.removeChild(messageEl);
                    }, 2000);
                };
                const itemDiv = document.createElement("div");
                itemDiv.style.wordWrap = "break-word";
                itemDiv.style.marginBottom = "20px";
                itemDiv.textContent = `${index + 1}. ${item}`;
                itemDiv.appendChild(copyEl);
                newContent.appendChild(itemDiv);
            });
            helpCard.appendChild(newContentHeading);
            helpCard.appendChild(newContent);
        }
    }
}
(0, $c2243597a68bc60b$export$2cd8252107eb640b)({
    loginButton: $b581aa09546ecf82$var$loginButtonSelector,
    logoutButton: $b581aa09546ecf82$var$logoutButtonSelector,
    updateUsageInfo: $b581aa09546ecf82$var$updateUsageInfo
});

})();
//# sourceMappingURL=verdaccio-5.js.map
